// mydatafeed/datafeed_price_feed.js
import { API_URL } from "../api-config.js";
import { ensureRealtimeSocketPF, closeRealtimeIfIdlePF } from "./services/realtime_price_feed.js";
import { subscribePriceFeed, unsubscribePriceFeed, getSubscriberCountPF } from "./websocket_price_feed.js";
import { fetchMidPriceHistory } from "./services/api.js";
import { toMs, toSec } from "./core/time.js";
import { endOfHistory, inflight, lastSentBars } from "./core/state.js";

const configurationData = {
    supportedResolutions: ["1", "5", "30", "1H"],
    supports_timescale_marks: true,
};

const keySR = (s, r) => `${s}:${r}`;

const DatafeedPriceFeed = {
    updateBars: true,
    _overrideBars: null,
    _lastBar: null,

    onReady: (cb) => {
        console.log("=====Price Feed onReady running. configurationData=", configurationData);
        setTimeout(() => cb(configurationData), 0);
    },

    resolveSymbol: (_symbolName, onSymbolResolved) => {
        const symbol = {
            name: "USDCLP",
            description: "USD/CLP Price Feed",
            type: "forex",
            session: "24x7",
            timezone: "America/Santiago",
            exchange: "",
            minmov: 1,
            pricescale: 100,
            has_intraday: true,
            visible_plots_set: "ohlcv",
            has_weekly_and_monthly: false,
            supported_resolutions: configurationData.supportedResolutions,
            data_status: DatafeedPriceFeed.updateBars ? "streaming" : "end",
        };
        setTimeout(() => onSymbolResolved(symbol), 0);
    },

    subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID) => {
        if (!DatafeedPriceFeed.updateBars) return;
        ensureRealtimeSocketPF();
        subscribePriceFeed(subscriberUID, onRealtimeCallback);
    },

    unsubscribeBars: (subscriberUID) => {
        unsubscribePriceFeed(subscriberUID);
        closeRealtimeIfIdlePF(getSubscriberCountPF() === 0);
    },

    async getBars(symbolInfo, resolution, periodParams, onHistory, onError) {
        const { from, to, firstDataRequest } = periodParams || {};
        const sym = symbolInfo.ticker || symbolInfo.name || "USDCLP";
        const histKey = keySR(sym, resolution);
        const sig = `${histKey}:${from}:${to}`;

        if (inflight.has(sig)) return;
        inflight.add(sig);

        try {
            console.log("[PriceFeed getBars]", { sym, resolution, from, to, firstDataRequest });

            let dataInit;

            const token = localStorage.getItem("token");

            // Para Price Feed, usamos directamente el historial de mid_price
            // Podríamos implementar caché luego si es necesario, por ahora fetch fresco
            dataInit = await fetchMidPriceHistory({ API_URL, token });


            if (!dataInit || dataInit.length < 1) {
                onHistory([], { noData: true });
                return;
            }

            const oldestMs = dataInit.reduce((min, b) => Math.min(min, b.time), Infinity);
            const reqToMsExclusive = toMs(to || 0) - 1;

            if (!firstDataRequest && reqToMsExclusive <= oldestMs) {
                endOfHistory.set(histKey, true);
                onHistory([], { noData: true });
                return;
            }

            const nextTime = toSec(oldestMs) - 1;
            onHistory(dataInit, { noData: false, nextTime });

            const subscriberUID = `${symbolInfo.ticker}_#_${resolution}`;
            if (dataInit.length > 0) {
                lastSentBars[subscriberUID] = dataInit[dataInit.length - 1];
            }
        } catch (err) {
            onError(err);
        } finally {
            inflight.delete(sig);
        }
    },
};

export default DatafeedPriceFeed;
